import { withRouter } from "react-router-dom";

// Components
import SingleselectFilter from "../../../components/attribute_catalog/filters/singleselect_filter";

export default withRouter(SingleselectFilter);
